var exports = {
  "zr": "ChessBoard.module__root___ZzhvTV",
  "OC": "ChessBoard.module__player___ZzhvTV",
  "Xu": "ChessBoard.module__playerName___ZzhvTV",
  "pm": "ChessBoard.module__clock___ZzhvTV",
  "no": "ChessBoard.module__board___ZzhvTV",
  "Ew": "ChessBoard.module__square___ZzhvTV",
  "BB": "ChessBoard.module__light___ZzhvTV",
  "XT": "ChessBoard.module__dark___ZzhvTV",
  "fV": "ChessBoard.module__piece___ZzhvTV",
  "C6": "ChessBoard.module__whitePiece___ZzhvTV",
  "cq": "ChessBoard.module__blackPiece___ZzhvTV",
  "z3": "ChessBoard.module__error___ZzhvTV",
};

module.exports = exports;
